export const treemapData = [
	{
		name: 'Oceania',
		children: [
			{ name: 'A', value: 800 },
			{ name: 'B', value: 200 },
			{ name: 'C', value: 100 },
			{ name: 'D', value: 900 },
		],
	},
	{
		name: 'Europe',
		children: [
			{ name: 'France', value: 2800, showLabel: true },
			{ name: 'Germany', value: 10000, showLabel: true },
			{ name: 'Sweden', value: 500 },
			{ name: 'England', value: 500 },
			{ name: 'Italy', value: 200 },
		],
	},
	{
		name: 'America',
		children: [
			{ name: 'U.S.', value: 3500, showLabel: true },
			{ name: 'Brazil', value: 3000, showLabel: true },
			{ name: 'Mexico', value: 2000, showLabel: true },
			{ name: 'AA', value: 500 },
			{ name: 'BB', value: 100 },
			{ name: 'CC', value: 500 },
			{ name: 'DD', value: 500 },
			{ name: 'EE', value: 400 },
			{ name: 'FF', value: 600 },
			{ name: 'GG', value: 200 },
			{ name: 'HH', value: 800 },
			{ name: 'II', value: 900 },
			{ name: 'JJ', value: 100 },
			{ name: 'KK', value: 900 },
		],
	},
	{
		name: 'Australia',
		children: [
			{ name: 'KH', value: 2000 },
			{ name: 'LL', value: 400 },
			{ name: 'MM', value: 500 },
			{ name: 'NN', value: 100 },
			{ name: 'OO', value: 1000 },
			{ name: 'PP', value: 800 },
			{ name: 'QQ', value: 700 },
			{ name: 'RR', value: 200 },
			{ name: 'ST', value: 300 },
		],
	},
	{
		name: 'Africa',
		children: [
			{ name: 'Nigeria', value: 2300, showLabel: true },
			{ name: 'TT', value: 2000 },
			{ name: 'UU', value: 500 },
			{ name: 'VV', value: 1200 },
			{ name: 'WW', value: 2000 },
			{ name: 'XX', value: 800 },
			{ name: 'YY', value: 2000 },
			{ name: 'ZZ', value: 500 },
			{ name: 'ABC', value: 1200 },
			{ name: 'CBA', value: 1500 },
		],
	},
	{
		name: 'Asia',
		children: [
			{
				name: 'China',
				value: 12500,
				showLabel: true,
			},
			{
				name: 'Iran',
				value: 22500,
				showLabel: true,
			},
			{
				name: 'Myanmar',
				value: 12500,
				showLabel: true,
			},
		],
	},
];

export const treemapOptions = {
	title: 'Treemap',
};
